export default {
  namespased: true,
  state: {
    changed: false,
    drive_type: '',
    transmission_type: '',
    number_of_doors: 4,
    upholstery_type: '',
    rims_diameter: '',
    rims_type: ''
  },
  getters: {
  },
  actions: {
  },
  mutations: {
    updateAuto(state, payload){
      state[payload.obj] = payload.value;
      state['changed'] = true;
    },
    updateChanged(state, value){
      state['changed'] = value;
    }
  }
}